// src/utils/attribution.js — 방문자가 어디서 들어왔는지 (도입 상담 신청의 '유입 경로')
// 탭 세션의 첫 방문 때 한 번 기록한다 (sessionStorage — 다른 탭·다음 방문과 섞이지 않음).
//   ref     : 외부 사이트 호스트만 (예: search.naver.com) — 주소 전체나 검색어는 남기지 않는다
//   landing : 처음 본 화면 경로 (예: /blog/qr-entry)
//   utm_*   : 광고 링크의 캠페인 값
// 새 광고 링크나 다른 사이트에서 다시 들어오면 그 방문으로 바꾼다. 사이트 안에서 옮겨 다니는 것은 그대로.
const KEY = 'gt_attr';
const UTM = ['utm_source', 'utm_medium', 'utm_campaign'];

const read = () => {
  try {
    const v = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
    return v && typeof v === 'object' ? v : null;
  } catch (e) {
    return null;
  }
};

export function captureAttribution() {
  try {
    if (typeof window === 'undefined' || window.__GATEON_PRERENDER__) return;
    const params = new URLSearchParams(window.location.search);
    const utm = {};
    UTM.forEach((k) => {
      const v = (params.get(k) || '').trim();
      if (v) utm[k] = v.slice(0, 100);
    });
    let ref = '';
    try {
      const r = document.referrer ? new URL(document.referrer) : null;
      if (r && /^https?:$/.test(r.protocol) && r.hostname !== window.location.hostname) ref = r.hostname.toLowerCase();
    } catch (e) { /* 잘못된 referrer 는 무시 */ }

    const stored = read();
    const fresh = Object.keys(utm).length > 0 || (ref && (!stored || stored.ref !== ref));
    if (stored && !fresh) return;
    const next = { landing: window.location.pathname.slice(0, 200), ...utm };
    if (ref) next.ref = ref;
    window.sessionStorage.setItem(KEY, JSON.stringify(next));
  } catch (e) {
    /* 저장소를 쓸 수 없는 환경(사생활 보호 모드 등) — 기록 없이 진행 */
  }
}

export function getAttribution() {
  const v = read();
  if (!v) return null;
  const out = {};
  ['ref', 'landing', ...UTM].forEach((k) => {
    if (typeof v[k] === 'string' && v[k]) out[k] = v[k];
  });
  return Object.keys(out).length ? out : null;
}
